<app-hero
	[title]="'hero.auctions' | translate"
	[imageDesktop]="market ? 'assets/hero/HP-hero-' + (market === 'ES' ? 'ES-' : '') + '3840x400.jpg' : null"
	[imageMobile]="market ? 'assets/hero/HP-hero-' + (market === 'ES' ? 'ES-' : '') + '768x180.jpg' : null"
/>
<section class="container-xxl mh-500">
	@if (filteredLeasysAuctions || filteredMultiAuctions || filteredOtherAuctions) {
		@let allAuctions = filteredLeasysAuctions.concat(filteredMultiAuctions).concat(filteredOtherAuctions);
		<section class="form px-sm-3 pt-3 pt-lg-5">
			<ng-template #searchRecap>
				<a
					href="#"
					class="ck-link mt-2 mt-lg-0 ps-0 ps-lg-3 d-block d-lg-inline"
					(click)="$event.preventDefault(); resetSearch()"
				>
					{{ "auction.search.cancelSearch" | translate }}
				</a>
				@if (advancedSearchTriggered) {
					<div class="d-flex flex-wrap gap-2 pt-3">
						@if (previousAdvancedSearchValue.brand) {
							<button
								type="button"
								class="btn btn-outline text-truncate bg-lightgray text-uppercase d-inline-flex align-items-center text-xs"
								title="{{ 'auction.details.brand' | translate }}: {{ previousAdvancedSearchValue.brand }}"
								(click)="refreshSearchByRemoving('brand')"
							>
								{{ "auction.details.brand" | translate }}: {{ previousAdvancedSearchValue.brand }}
								<span class="d-inline-block plus plus-rotated plus-small ms-1"></span>
							</button>
						}

						@if (previousAdvancedSearchValue.model) {
							<button
								type="button"
								class="btn btn-outline text-truncate bg-lightgray text-uppercase d-inline-flex align-items-center text-xs"
								title="{{ 'auction.details.model' | translate }}: {{ previousAdvancedSearchValue.model }}"
								(click)="refreshSearchByRemoving('model')"
							>
								{{ "auction.details.model" | translate }}: {{ previousAdvancedSearchValue.model }}
								<span class="d-inline-block plus plus-rotated plus-small ms-1"></span>
							</button>
						}

						@if (previousAdvancedSearchValue.kmFrom !== kmRange[0] || previousAdvancedSearchValue.kmTo !== kmRange[1]) {
							<button
								type="button"
								class="btn btn-outline text-truncate bg-lightgray text-uppercase d-inline-flex align-items-center text-xs"
								title="{{ 'auction.details.licensePlate' | translate }}: {{ previousAdvancedSearchValue.kmFrom }} - {{ previousAdvancedSearchValue.kmTo }}"
								(click)="refreshSearchByRemoving('km')"
							>
								{{ (market === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}: {{ previousAdvancedSearchValue.kmFrom }} -
								{{ previousAdvancedSearchValue.kmTo }}
								@if (previousAdvancedSearchValue.kmTo === kmRange[1]) {
									+
								}
								<span class="d-inline-block bg-transparent plus plus-rotated plus-small ms-1"></span>
							</button>
						}

						@if (previousAdvancedSearchValue.registrationYearFrom !== registrationYearRange[0] || previousAdvancedSearchValue.registrationYearTo !== registrationYearRange[1]) {
							<button
								type="button"
								class="btn btn-outline text-truncate bg-lightgray text-uppercase d-inline-flex align-items-center text-xs"
								title="{{ 'auction.details.frame' | translate }}: {{ previousAdvancedSearchValue.registrationYearFrom }} - {{ previousAdvancedSearchValue.registrationYearTo }}"
								(click)="refreshSearchByRemoving('registrationYear')"
							>
								{{ "auction.details.year" | translate }}: {{ previousAdvancedSearchValue.registrationYearFrom }} - {{ previousAdvancedSearchValue.registrationYearTo }}
								<span class="d-inline-block bg-transparent plus plus-rotated plus-small ms-1"></span>
							</button>
						}

						@if (!savedSearch) {
							<div class="ck-tooltipSwitch">
								<aside class="ck-tooltip above text-center">{{ "auction.search.saveSearchButtonTooltip" | translate }}</aside>
								<button
									type="button"
									class="btn btn-blue text-uppercase"
									(click)="saveSearch()"
								>
									{{ "auction.search.saveSearchCTA" | translate }}
								</button>
							</div>
						}
					</div>
				}
			</ng-template>
			<!-- Not showing auction search on DE and
			when there are no auctions (before searching: when I search, I can get an empty response).
			Read as: there is a search value (hence there may be no search results) OR, otherwise, there are any results. Otherwise, it means that there are no auctions at all and the form isn't shown.
			In order to have triggered a search, the form had to be visible in past => there are auctions -->
			@if ((previousSearchValue || advancedSearchTriggered || allAuctions.length) && market && market !== "DE") {
				<div class="border-bottom-gray pb-3">
					<h4 class="text-blue text-lg text-lg-center pb-3 fw-bold">{{ "auction.search.searchTitle" | translate }}</h4>
					<!-- TODO: facendo switch tra le ricerche, svuotare la precedente perché non ha più senso -->

					@if (!advancedSearchView) {
						<!-- NOTE: DO NOT invert the if clauses cause it would change animation look -->
						<form
							class="d-grid"
							animate.enter="open-base-search"
							animate.leave="close-base-search"
							(ngSubmit)="search(searchInput.value)"
						>
							<div
								[style.minHeight]="0"
								class="searchField mx-auto text-end"
							>
								<div class="d-flex d-lg-flex border bg-white">
									<input
										type="text"
										class="border-0 px-3 py-2 flex-grow-1 focus-ring"
										#searchInput
										[placeholder]="'auction.search.searchPlaceholder' | translate"
									/>
									<button
										type="submit"
										class="btn btn-transparent btn-ico btn-ico-search-after focus-ring"
									></button>
								</div>
								<button
									type="button"
									class="btn btn-transparent ck-link"
									(click)="advancedSearchView = true"
								>
									{{ "auction.search.advancedSearch" | translate }}
								</button>
							</div>
						</form>
					} @else {
						<div
							class="d-grid bg-white rounded-4 ck-shadow mx-auto position-relative"
							animate.enter="open-advanced-search"
							animate.leave="close-advanced-search"
						>
							<form
								[style.minHeight]="0"
								[formGroup]="advancedSearchForm"
								(ngSubmit)="submitAdvancedSearch()"
							>
								<div class="row pt-4 px-3">
									<div class="field col-12 col-md-6 mb-3 px-md-3 px-lg-4 px-xl-5">
										<label for="brandInput">{{ "auction.details.brand" | translate }}</label>
										<input
											formControlName="brand"
											class="defaultInput mt-2"
											id="brandInput"
											type="text"
										/>
									</div>
									<div class="field col-12 col-md-6 mb-3 px-md-3 px-lg-4 px-xl-5">
										<label for="modelInput">{{ "auction.details.model" | translate }}</label>
										<input
											formControlName="model"
											class="defaultInput mt-2"
											id="modelInput"
											type="text"
										/>
									</div>
									<div class="field3 col-12 col-md-6 mb-3 px-md-3 px-lg-4 px-xl-5">
										<label>{{ "auction.details.year" | translate }}</label>
										<ngx-slider
											formControlName="registrationYear"
											[options]="{ floor: registrationYearRange[0], ceil: registrationYearRange[1] }"
										/>
									</div>
									<div class="field3 col-12 col-md-6 mb-3 px-md-3 px-lg-4 px-xl-5">
										<label>{{ (market === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}</label>
										<ngx-slider
											formControlName="km"
											[options]="{ floor: kmRange[0], ceil: kmRange[1], step: kmStep, translate: getKmLabel }"
										/>
									</div>
									<div class="col-12 px-md-3 px-lg-4 px-xl-5 my-4 text-end">
										<button
											type="submit"
											class="btn btn-blue text-uppercase"
											[disabled]="formUntouched()"
										>
											{{ "auction.search.search" | translate }}
										</button>
									</div>
								</div>
							</form>
							<button
								type="button"
								class="close-x position-absolute top-0 end-0 mt-3 me-3"
								(click)="advancedSearchView = false"
							></button>
						</div>
					}
					<!-- A search had been triggered, but there are no results -->
					@if ((previousSearchValue || advancedSearchTriggered) && !allAuctions.length) {
						<div class="pt-3">
							<strong class="text-blue"> {{ "auction.search.noSearchResults" | translate }}</strong>
							<ng-container *ngTemplateOutlet="searchRecap" />
						</div>
					}
				</div>
			}
			<!-- A search had been triggered, and there are results -->
			@if (previousSearchValue || advancedSearchTriggered) {
				@if (allAuctions.length) {
					<div class="pt-3">
						@if (advancedSearchTriggered) {
							<!-- Advanced search -->
							@if (allAuctions.length > 1) {
								<span
									class="text-blue"
									[innerHTML]="'auction.details.weFoundNMatches' | translate: { num: allAuctions.length }"
								></span>
							} @else {
								<span
									class="text-blue"
									[innerHTML]="'auction.details.weFound1Match' | translate"
								></span>
							}
						} @else {
							<!-- Simple search -->
							<span
								class="text-blue"
								[innerHTML]="'auction.search.weFoundX' | translate: { searchString: previousSearchValue }"
							></span>
						}
						<ng-container *ngTemplateOutlet="searchRecap" />
					</div>
				}
			}
			<!-- No search and we have no auctions: there are no available auctions -->
			@else {
				@if (!allAuctions.length) {
					<div class="pt-5 text-center">
						<span class="text-blue text-xl"> {{ "auction.search.noAuctions" | translate }}</span>
					</div>
				}
			}
		</section>

		@if (allAuctions.length) {
			@if (!(previousSearchValue || advancedSearchTriggered)) {
				<main class="auction-topbar mb-2 pt-3">
					<div class="auction-topbar-left">
						<span class="top-label"> {{ runningCount }} {{ "auctions.running" | translate }}</span>
						<span class="separator">|</span>
						<span class="top-label"> {{ scheduledCount }} {{ "auctions.scheduled" | translate }}</span>
					</div>
				</main>
			}

			@for (auction of allAuctions; track auction.idAuction) {
				<app-auction-card
					[auction]="auction"
					[randomVehicles]="randomVehicles"
					[showAuctionType]="showAuctionType"
				>
				</app-auction-card>
			}
		}
	} @else {
		<!-- Still downloading the auctions on landing -->
		<div class="pt-5 text-center">
			<span class="text-blue text-xl"> {{ "auction.retrievingAuctions" | translate }}</span>
		</div>
	}
</section>